// extracted by mini-css-extract-plugin
export default {"filter":"QuestionList_filter__FZheD","fadeIn":"QuestionList_fadeIn__bfJuc","tblheader":"QuestionList_tblheader__eMGEy","btn":"QuestionList_btn__8nxRQ"};